module.exports = __webpack_public_path__ + "static/fonts/342F4F_11_0.122240d.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_11_0.woff
// module id = 108
// module chunks = 4